import { useEffect } from 'react';

import { useMessage } from '@ott/message';

export type UseToastProps = {
  showToast: boolean;
  toast: JSX.Element;
  anchor: string;
  componentClassName?: string;
  containerClassName?: string;
};

const useToast = ({
  showToast,
  toast,
  anchor,
  componentClassName,
  containerClassName,
}: UseToastProps) => {
  const messageApi = useMessage();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (showToast) {
      messageApi.open(toast, {
        placement: 'bottom',
        duration: Infinity,
        key: anchor,
        className: componentClassName,
        childrenClassNames: {
          container: containerClassName,
        },
      });
    } else {
      messageApi.close(anchor);
    }
  }, [showToast, messageApi]);
};

export default useToast;
